import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
// import logo from '../../assets/img/illustrations/falcon.png';
import logo from '../../assets/hippo/img/logo.png';
import { changeDashboardPath } from "../../app/store/reducers/main/mainReducer";
import { useDispatch } from "react-redux";

const Logo = ({ at = 'auth', width = 58, className, textClass, ...rest }) => {

  const dispatch = useDispatch();

  return (
    <Link
      to="/"
      onClick={() => dispatch(changeDashboardPath())}
      className={classNames(
        'text-decoration-none d-none d-lg-inline',
        { 'navbar-brand text-left': at === 'navbar-vertical' },
        { 'navbar-brand text-left': at === 'navbar-top' }
      )}
      {...rest}
    >
      <div
        className={classNames(
          'd-flex',
          {
            'align-items-center py-3': at === 'navbar-vertical',
            'align-items-center': at === 'navbar-top',
            'flex-center fw-bolder fs-5 mb-4': at === 'auth'
          },
          className
        )}
      >
        <img className="me-2" src={logo} alt="Logo" width={width} />
        <span className={classNames('font-sans-serif', textClass)}>Hippo</span>
      </div>
    </Link>
  );
};

Logo.propTypes = {
  at: PropTypes.oneOf(['navbar-vertical', 'navbar-top', 'auth']),
  width: PropTypes.number,
  className: PropTypes.string,
  textClass: PropTypes.string
};

// Logo.defaultProps = { at: 'auth', width: 58 };

export default Logo;
